import { pick, keys, omit } from 'lodash';

import { formatNumber, transformIncluded } from 'modules/common/utils';

const key = {
  id: '',
  rate: 0,
  uuid: '',
  status: '',
  banner: '',
  branch: '',
  logo_url: '',
  user_count: 0,
  product_count: 0,
  opening_time: '',
  closing_time: '',
  business_name: '',
  address_details: '',
  operation_days: '',
  customers_count: '',
  operation_status: false,
  completed_orders_count: '',
  delivery_type: '',
};

export const transformMerchant = (data, included) => {
  const $data = transformIncluded(data, included);
  const { ratingsCount = {} } = $data?.included || {};

  const {
    is_open,
    branch_name,
    branch_user_count = 0,
    inventory_products_count = 0,
    store_operations,
  } = $data?.attributes;

  const args = {
    ...omit($data, ['attributes']),
    ...$data?.attributes,
    branch: branch_name,
    status: is_open,
    rate: ratingsCount?.attributes?.average ?? 0,
    user_count: formatNumber(branch_user_count, 0),
    product_count: formatNumber(inventory_products_count, 0),
    operation_days: Object.entries(store_operations || {})
      ?.filter((item) => item?.[1])
      ?.map((item) => item?.[0]),
    id: +data?.id,
  };

  const x = { ...pick(args, keys(key)) };

  return x;
};
